import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Buttons = props => (
  <section className="module-filter top">
    <div className="flex wrap">
      {/* Type */}
      <div className="flex filter-box">
        <h2 id="selectType" className="container-filter-h2 column-filter">
          <span>{props.language.summary.filter.formTypes}:</span>
          <div>{props.filter.selectType ? props.filter.selectType : props.language.summary.filter.all}</div>
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectType"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectType}
                />{' '}
              </li>
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-parent="selectType"
                  onClick={props.handleFilter}
                  data-select={'ALL'}
                >
                  {props.language.summary.filter.all}
                </a>
              </li>

              {_.filter(props.datosFilter.formTypes, o => {
                return o.name.toUpperCase().indexOf(props.input.selectType.toUpperCase()) > -1;
              }).map((item, i) => (
                <li key={i}>
                  <a
                    role="button"
                    data-parent="selectType"
                    data-select={item.name}
                    data-name={item.name}
                    tabIndex={0}
                    onClick={props.handleFilter}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {/* Inspector */}
      <div className="flex filter-box">
        <h2 id="selectInspector" className="container-filter-h2 column-filter">
          <span>{props.language.summary.filter.existentUsers}:</span>
          <div>{props.filter.selectInspector
            ? props.filter.selectInspector
            : props.language.summary.filter.all}</div>
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectInspector"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectInspector}
                />{' '}
              </li>
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-parent="selectInspector"
                  onClick={props.handleFilter}
                  data-select={'ALL'}
                >
                  {props.language.summary.filter.all}
                </a>
              </li>
              {_.filter(props.datosFilter.existentUsers, o => {
                return o.name.toUpperCase().indexOf(props.input.selectInspector.toUpperCase()) > -1;
              }).map((item, i) => (
                <li key={i}>
                  <a
                    role="button"
                    data-parent="selectInspector"
                    data-select={item.id}
                    data-name={item.name}
                    tabIndex={0}
                    onClick={props.handleFilter}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {/* Driver */}
      <div className="flex filter-box">
        <h2 id="selectDriver" className="container-filter-h2 column-filter">
          <span>{props.language.summary.filter.existentPersons}:</span>
          <div>{props.filter.selectDriver
            ? props.filter.selectDriver
            : props.language.summary.filter.all}</div>
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectDriver"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectDriver}
                />{' '}
              </li>
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-parent="selectDriver"
                  onClick={props.handleFilter}
                  data-select={'ALL'}
                >
                  {props.language.summary.filter.all}
                </a>
              </li>
              {_.filter(props.datosFilter.existentPersons, o => {
                return o.name.toUpperCase().indexOf(props.input.selectDriver.toUpperCase()) > -1;
              }).map((item, i) => (
                <li key={i}>
                  <a
                    role="button"
                    data-parent="selectDriver"
                    data-select={item.id}
                    data-name={item.name}
                    tabIndex={0}
                    onClick={props.handleFilter}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {/* Vehicle */}
      <div className="flex filter-box">
        <h2 id="selectVehicle" className="container-filter-h2 column-filter">
          <span>{props.language.summary.filter.existentVehicles}:</span>
          <div>{props.filter.selectVehicle
            ? props.filter.selectVehicle
            : props.language.summary.filter.all}</div>
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectVehicle"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectVehicle}
                />{' '}
              </li>
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-parent="selectVehicle"
                  onClick={props.handleFilter}
                  data-select={'ALL'}
                >
                  {props.language.summary.filter.all}
                </a>
              </li>
              {_.filter(props.datosFilter.existentVehicles, o => {
                return o.name.toUpperCase().indexOf(props.input.selectVehicle.toUpperCase()) > -1;
              }).map((item, i) => (
                <li key={i}>
                  <a
                    role="button"
                    data-parent="selectVehicle"
                    data-select={item.id}
                    data-name={item.name}
                    tabIndex={0}
                    onClick={props.handleFilter}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {/* Form */}
      <div className="flex filter-box">
        <h2 id="selectForm" className="container-filter-h2 column-filter">
          <span>{props.language.summary.filter.existentForms}:</span>
          <div>{props.filter.selectForm ? props.filter.selectForm : props.language.summary.filter.all}</div>
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectForm"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectForm}
                />{' '}
              </li>
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-parent="selectForm"
                  onClick={props.handleFilter}
                  data-select={'ALL'}
                >
                  {props.language.summary.filter.all}
                </a>
              </li>
              {_.filter(props.datosFilter.existentForms, o => {
                return o.title.toUpperCase().indexOf(props.input.selectForm.toUpperCase()) > -1;
              }).map((item, i) => (
                <li key={i}>
                  <a
                    role="button"
                    data-parent="selectForm"
                    data-select={item.id}
                    data-name={item.title}
                    tabIndex={0}
                    onClick={props.handleFilter}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {/* Fails */}
      <div className="flex filter-box">
        <h2 id="selectFails" className="container-filter-h2 column-filter">
          <span>{props.language.summary.filter.existentFails}:</span>
          <div>{props.filter.selectFails ? props.filter.selectFails : props.language.summary.filter.all}</div>
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li no-padding">
            <i className="fas fa-caret-down" />
            <ul onMouseLeave={props.handleChangeReset}>
              <li>
                {' '}
                <input
                  type="text"
                  data-update="selectFails"
                  onChange={props.handleChange}
                  autoComplete="off"
                  value={props.input.selectFails}
                />{' '}
              </li>
              <li>
                <a
                  role="button"
                  tabIndex={0}
                  data-parent="selectFails"
                  onClick={props.handleFilter}
                  data-select={'ALL'}
                >
                  {props.language.summary.filter.all}
                </a>
              </li>
              {_.filter(props.datosFilter.existentFails, o => {
                return o.name.toUpperCase().indexOf(props.input.selectFails.toUpperCase()) > -1;
              }).map((item, i) => (
                <li key={i}>
                  <a
                    role="button"
                    data-parent="selectFails"
                    data-name={item.name}
                    data-select={item.name}
                    tabIndex={0}
                    onClick={props.handleFilter}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      {/* Question 1 */}
      {props.filterQuestion.filterQuestion1Value.state && (
        <div className="flex filter-box">
          <h2 id="question1" className="container-filter-h2 column-filter">
            <span>{props.filterQuestion.filterQuestion1Value[`${props.languageFormat}`]}:</span>
            <div>{props.filter.question1 ? props.filter.question1 : props.language.summary.filter.all}</div>
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li no-padding">
              <i className="fas fa-caret-down" />
              <ul onMouseLeave={props.handleChangeReset}>
                <li>
                  {' '}
                  <input
                    type="text"
                    data-update="question1"
                    onChange={props.handleChange}
                    autoComplete="off"
                    value={props.input.question1}
                  />{' '}
                </li>
                <li>
                  <a
                    role="button"
                    tabIndex={0}
                    data-parent="question1"
                    onClick={props.handleFilter}
                    data-select={'ALL'}
                    data-special={
                      props.filterQuestion.filterQuestion1Value[`${props.languageFormat}`]
                    }
                  >
                    {props.language.summary.filter.all}
                  </a>
                </li>
                {_.filter(props.datosFilter.existentQuestion1, o => {
                  return o.name.toUpperCase().indexOf(props.input.question1.toUpperCase()) > -1;
                }).map((item, i) => (
                  <li key={i}>
                    <a
                      role="button"
                      data-parent="question1"
                      data-special={
                        props.filterQuestion.filterQuestion1Value[`${props.languageFormat}`]
                      }
                      data-name={item.name}
                      data-select={item.name}
                      tabIndex={0}
                      onClick={props.handleFilter}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      )}
      {/* Question 2 */}
      {props.filterQuestion.filterQuestion2Value.state && (
        <div className="flex filter-box">
          <h2 id="question2" className="container-filter-h2 column-filter">
            <span>{props.filterQuestion.filterQuestion2Value[`${props.languageFormat}`]}:</span>
            <div>{props.filter.question2 ? props.filter.question2 : props.language.summary.filter.all}</div>
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li no-padding">
              <i className="fas fa-caret-down" />
              <ul onMouseLeave={props.handleChangeReset}>
                <li>
                  {' '}
                  <input
                    type="text"
                    data-update="question2"
                    onChange={props.handleChange}
                    autoComplete="off"
                    value={props.input.question2}
                  />{' '}
                </li>
                <li>
                  <a
                    role="button"
                    tabIndex={0}
                    data-parent="question2"
                    onClick={props.handleFilter}
                    data-select={'ALL'}
                    data-special={
                      props.filterQuestion.filterQuestion2Value[`${props.languageFormat}`]
                    }
                  >
                    {props.language.summary.filter.all}
                  </a>
                </li>
                {_.filter(props.datosFilter.existentQuestion2, o => {
                  return o.name.toUpperCase().indexOf(props.input.question2.toUpperCase()) > -1;
                }).map((item, i) => (
                  <li key={i}>
                    <a
                      role="button"
                      data-parent="question2"
                      data-special={
                        props.filterQuestion.filterQuestion2Value[`${props.languageFormat}`]
                      }
                      data-name={item.name}
                      data-select={item.name}
                      tabIndex={0}
                      onClick={props.handleFilter}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      )}
      {/* Question 3 */}
      {props.filterQuestion.filterQuestion3Value.state && (
        <div className="flex filter-box">
          <h3 id="question3" className="container-filter-h2 column-filter">
            <span>{props.filterQuestion.filterQuestion3Value[`${props.languageFormat}`]}:</span>
            <div>{props.filter.question3 ? props.filter.question3 : props.language.summary.filter.all}</div>
          </h3>
          <ul className="container-filter-ul">
            <li className="container-filter-li no-padding">
              <i className="fas fa-caret-down" />
              <ul onMouseLeave={props.handleChangeReset}>
                <li>
                  {' '}
                  <input
                    type="text"
                    data-update="question3"
                    onChange={props.handleChange}
                    autoComplete="off"
                    value={props.input.question3}
                  />{' '}
                </li>
                <li>
                  <a
                    role="button"
                    tabIndex={0}
                    data-parent="question3"
                    onClick={props.handleFilter}
                    data-select={'ALL'}
                    data-special={
                      props.filterQuestion.filterQuestion3Value[`${props.languageFormat}`]
                    }
                  >
                    {props.language.summary.filter.all}
                  </a>
                </li>
                {_.filter(props.datosFilter.existentQuestion3, o => {
                  return o.name.toUpperCase().indexOf(props.input.question3.toUpperCase()) > -1;
                }).map((item, i) => (
                  <li key={i}>
                    <a
                      role="button"
                      data-parent="question3"
                      data-special={
                        props.filterQuestion.filterQuestion3Value[`${props.languageFormat}`]
                      }
                      data-name={item.name}
                      data-select={item.name}
                      tabIndex={0}
                      onClick={props.handleFilter}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      )}
    </div>
    <div className="flex excel_download_icon">
      <div className="box-form">
        <a className="excel" onClick={props.handleDownload}>
          <i className="fas fa-file-excel" />
        </a>
      </div>
    </div>
  </section>
);
Buttons.propTypes = {
  datosFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
    .isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired
};
export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/summary_inspections/buttons.jsx